var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortApplied = function SvgSortApplied(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "sort-arrow"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3020_5987",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3020_5987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_downward_alt",
    d: "M11.2492 13.125V7.75C11.2492 7.54167 11.3221 7.36458 11.4679 7.21875C11.6137 7.07292 11.7908 7 11.9992 7C12.2075 7 12.3846 7.07292 12.5304 7.21875C12.6762 7.36458 12.7492 7.54167 12.7492 7.75V13.125L14.4158 11.4583C14.5686 11.3056 14.7457 11.2292 14.9471 11.2292C15.1485 11.2292 15.3255 11.3056 15.4783 11.4583C15.6311 11.6111 15.7075 11.7882 15.7075 11.9896C15.7075 12.191 15.6311 12.3681 15.4783 12.5208L12.52 15.4792C12.3672 15.6319 12.1936 15.7083 11.9992 15.7083C11.8047 15.7083 11.6311 15.6319 11.4783 15.4792L8.51998 12.5208C8.36721 12.3681 8.29429 12.191 8.30123 11.9896C8.30818 11.7882 8.38804 11.6111 8.54082 11.4583C8.6936 11.3056 8.87068 11.2292 9.07207 11.2292C9.27346 11.2292 9.45054 11.3056 9.60332 11.4583L11.2492 13.125Z",
    fill: "#33445E"
  })))));
};
export default SvgSortApplied;